export default {
  request: PCONST.thrift.EventType.USER_PASSWORD_RESET_REQUEST,
  requestBegin: PCONST.thrift.EventType.USER_PASSWORD_RESET_REQUEST_BEGIN,
  requestEnd: PCONST.thrift.EventType.USER_PASSWORD_RESET_REQUEST_END,
};
